export const CONTEXT = "groups";
export const UPLOAD_PATH = "upload_path"+"/"+CONTEXT

export const CONTEXT_TITLE = {
  singular: "GROUP",
  plural: "GROUPS",
}